<div class="modal-body">
    <table class="mvd_table--primeng" *ngIf="messages.length">
        <thead>
            <tr>
                <th>Date</th>
                <th>Time</th>
                <th>Sender</th>
                <th>Message</th>
                <th class="w--icon">Delete</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let message of messages">
                <td>{{message.notificationMessageData.updatedDate | date:"MM/dd/yy"}}</td>
                <td>{{message.notificationMessageData.updatedDate | date:"HH:mm"}}</td>
                <td>{{message.senderFirstName}} {{message.senderLastName}}</td>
                <td class="w--break" [innerHTML]="message.notificationMessageData.messageText | safeHtml"></td>
                <td class="w--icon"><a class="icon--delete" data-bs-toggle="tooltip" href="javascript:void(0)" title="Delete" (click)="delete(message.notificationMessageData.notificationMessageDispositionId)"></a></td>
            </tr>
        </tbody>
    </table>

    <p class="mvd_form-group" *ngIf="!messages.length">You have no messages for selected business unit.</p>
</div>
<div class="modal-footer" *ngIf="messages.length && showDeleteAll">
    <div class="btn--group">
        <button class="btn--default" type="button" mat-dialog-close aria-label="Close">Cancel</button>
        <button class="btn--accent" type="button" (click)="deleteAll()">Delete All</button>
    </div>
</div>
